import { __read, __values } from "tslib";
export var getSizeMap = function (withResponsiveTokens) {
    var e_1, _a;
    var sizeMap = {};
    try {
        for (var withResponsiveTokens_1 = __values(withResponsiveTokens), withResponsiveTokens_1_1 = withResponsiveTokens_1.next(); !withResponsiveTokens_1_1.done; withResponsiveTokens_1_1 = withResponsiveTokens_1.next()) {
            var withResponsiveToken = withResponsiveTokens_1_1.value;
            var _b = __read(withResponsiveToken.split('.'), 2), size = _b[0], _c = _b[1], breakpointKey = _c === void 0 ? 'default' : _c;
            sizeMap[breakpointKey] = size;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (withResponsiveTokens_1_1 && !withResponsiveTokens_1_1.done && (_a = withResponsiveTokens_1.return)) _a.call(withResponsiveTokens_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return sizeMap;
};
export var getMatchedSize = function (sizeMap, matchDetail) {
    var matchedSize = null;
    // breakpoint > gtBreakpoint > ltBreakpoint > default
    if (matchDetail !== null) {
        var matchBP = matchDetail.matchBP, gtMatchGroup_1 = matchDetail.gtMatchGroup, ltMatchGroup_1 = matchDetail.ltMatchGroup;
        if (matchBP !== null && sizeMap[matchBP] !== undefined) {
            matchedSize = sizeMap[matchBP];
        }
        else {
            matchedSize = (function () {
                var e_2, _a, e_3, _b;
                try {
                    // high priority
                    for (var gtMatchGroup_2 = __values(gtMatchGroup_1), gtMatchGroup_2_1 = gtMatchGroup_2.next(); !gtMatchGroup_2_1.done; gtMatchGroup_2_1 = gtMatchGroup_2.next()) {
                        var gtBP = gtMatchGroup_2_1.value;
                        var size = sizeMap[gtBP];
                        if (size !== undefined)
                            return size;
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (gtMatchGroup_2_1 && !gtMatchGroup_2_1.done && (_a = gtMatchGroup_2.return)) _a.call(gtMatchGroup_2);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                try {
                    // low priority
                    for (var ltMatchGroup_2 = __values(ltMatchGroup_1), ltMatchGroup_2_1 = ltMatchGroup_2.next(); !ltMatchGroup_2_1.done; ltMatchGroup_2_1 = ltMatchGroup_2.next()) {
                        var ltBP = ltMatchGroup_2_1.value;
                        var size = sizeMap[ltBP];
                        if (size !== undefined)
                            return size;
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (ltMatchGroup_2_1 && !ltMatchGroup_2_1.done && (_b = ltMatchGroup_2.return)) _b.call(ltMatchGroup_2);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                return null;
            })();
        }
    }
    if (matchedSize === null && sizeMap.default !== undefined) {
        matchedSize = sizeMap.default;
    }
    return matchedSize;
};
